
import Cookies, {CookieAttributes} from 'js-cookie'
import {FormHelpers} from "./helpers/form-helpers";
import {Helpers} from "./helpers/helpers";

export class ConsentBanner {
	private rootUrl: string = "";
	private consentBanner: HTMLElement;
	private consentBannerOverlay: HTMLElement;

	private isIframe = false;
	constructor() {
		try {
			this.isIframe = window.self !== window.top;
		} catch (e) {			
		}
		this.consentBanner = document.querySelector('.cookie-consent');
		this.consentBannerOverlay = document.querySelector('.cookie-banner-overlay');

		this.checkConsent();		
		this.addBannerListeners()		
	}

	private addBannerListeners() {
		const self = this;
		document.addEventListener('submit', function (e) {			
			const target = e.target as HTMLFormElement;
			if (target && (target.classList.contains('agree-form') || target.classList.contains('decline-form'))) {
				const accept = target.classList.contains('agree-form');
				self.hideBanner(); //hide immediately
				self.consentBannerOverlay?.classList.add("d-none");
				document.body.classList.remove("no-scroll");
				FormHelpers.getAjax(`${self.rootUrl}/consent/act?agree=` + accept, response => {
					if (response) {
						ConsentCookie.addCookie(accept);						
						self.removeBanner(); //remove when ajax request is complete. 
						if (accept && !self.isIframe) {
							self.loadTrackingScripts();
						}
					}
				}, (error) => console.warn(error));
				e.preventDefault();
				return false;
			}
		});
	}

	private loadTrackingScripts() {
		let trackingScriptsContainer = document.querySelector('.tracking-scripts') as HTMLInputElement;
		let trackingScripts = decodeURIComponent(trackingScriptsContainer.value);

		let parser = new DOMParser();
		let doc = parser.parseFromString(trackingScripts, 'text/html');
		let scriptElements = doc.querySelectorAll('script');

		for (var i = 0; i < scriptElements.length; i++) {
			var scriptElement = document.createElement('script');
			scriptElement.innerHTML = scriptElements[i].innerHTML;
			document.head.appendChild(scriptElement);
		}
	}

	private checkConsent() {
		const cookie = Cookies.get(ConsentCookie.tensarCookieKey)
		const self = this;		
		if (cookie) {
			this.hideBanner(false); //do not post message to iframe to avoid the reload bug when accepted.
			return; //do nothing, they've already saw and accepted/declined. 
		}
		
		//no cookie exist, has not seen banner probably
		FormHelpers.getAjax(`${this.rootUrl}/consent/show-banner`, response => {
			const bannerResponse = JSON.parse(response) as BannerConsentResponse;
			if (bannerResponse.showBanner && window.location.host !== 'author.tensar.co.uk') {
				self.showBanner()
			
			} else {
				ConsentCookie.addCookie(bannerResponse.isConsentAgree);
			}

		}, (error) => console.warn(error));


	}
	private showBanner() {		
		this.postMessage("show_consent");
		this.consentBanner?.classList.remove('d-none');
		this.consentBannerOverlay?.classList.remove("d-none");	
		//document.body.classList.add("no-scroll");
	}
	private removeBanner() {		
		this.postMessage("close_consent");
		this.consentBanner?.classList.add('d-none');
	}
	
	private hideBanner(shouldPostMessage = true) {
		if (shouldPostMessage) {
			this.postMessage("hide_consent");
		}
		this.consentBanner?.classList.add('d-none');
	}	
	
	private postMessage(message: string) {
		top.postMessage(message, '*');
		
	}
}

export class ConsentCookie {
	static tensarCookieKey = "Tensar_Cookie_Consent"
	public static addCookie(agree: boolean) {
		const cookieAttributes: CookieAttributes = {
			expires: 365,
			sameSite: "none",
			secure: true
		};
		Cookies.set(ConsentCookie.tensarCookieKey, agree.toString(), cookieAttributes)
	}
}


export interface BannerConsentResponse {
	showBanner: boolean,
	isConsentAgree: boolean
}